import React, { useEffect, useState } from "react";

import { Backtotop, Underline } from "../../widgets";
import EventCard from "../../components/Event_card/EventCard";
import programmes from "../../constants/programmes";
import "./Programs_organized.css";

const Programs_organized = () => {
  const [filterMonth, setFilterMonth] = useState(null);
  const [visibleCount, setVisibleCount] = useState(6);
  const [filterYear, setFilterYear] = useState("ALL");

  useEffect(() => {
    document.title = "ACCET-programme";
  }, []);

  // Reset visible items when month changes
  useEffect(() => {
    setVisibleCount(6);
  }, [filterMonth,filterYear]);

  const getMonthShort = (dateValue) => {
    if (!dateValue) return null;

    const numbers = dateValue.match(/\d+/g);
    if (!numbers || numbers.length < 2) return null;

    let monthNum;

    if (numbers[0].length === 4) {
      monthNum = numbers[1];
    } else {
      monthNum = numbers[1];
    }
   
    const months = [
      "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
      "JUL", "AUG", "SEP", "OCT", "NOV", "DEC",
    ];

    return months[parseInt(monthNum, 10) - 1] || null;
  };
 const getYear = (dateValue) => {
  if (!dateValue) return null;
  const match = dateValue.match(/\d{4}/);
  return match ? match[0] : null;
};

  // Filter by month and year
  const filteredProgrammes = programmes.filter((event) => {
  const eventMonth = getMonthShort(event.date);
  const eventYear = getYear(event.date);

  const monthMatch = !filterMonth || eventMonth === filterMonth;
  const yearMatch = filterYear === "ALL" || eventYear === filterYear;

  return monthMatch && yearMatch;
});

  // Show only required count
  const visibleProgrammes = filteredProgrammes.slice(0, visibleCount);

  const months = [
    "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
    "JUL", "AUG", "SEP", "OCT", "NOV", "DEC",
  ];

  return (
    <div className="programme">
      <Underline heading="IQAC - Programmes" />

      {/* Month Filter */}
      <div className="month-bar">
        <select
  className="year-dropdown"
  value={filterYear}
  onChange={(e) => setFilterYear(e.target.value)}
>
  <option value="ALL">Year</option>
  <option value="2025">2025</option>
  <option value="2026">2026</option>
</select>
        <button
  className={!filterMonth ? "active" : ""}
  onClick={() => setFilterMonth(null)}
>
  ALL
</button>



        {months.map((month) => (
          <button
            key={month}
            className={filterMonth === month ? "active" : ""}
            onClick={() => setFilterMonth(month)}
          >
            {month}
          </button>
        ))}
      </div>

      {/* Programmes Section */}
      <section className="programmedark">
        <div
          className={
            visibleProgrammes.length === 1
              ? "events-grid single-card-wrapper"
              : "events-grid"
          }
        >
          {visibleProgrammes.length === 0 ? (
            <p className="month_no_events">No events found</p>
          ) : (
            visibleProgrammes.map((event, idx) => (
              <EventCard key={idx} event={event} index={idx} />
            ))
          )}
        </div>

        {/* View More Button */}
        {filteredProgrammes.length > visibleCount && (
          <div className="view-more-wrapper">
            <button
              className="view-more-btn"
              onClick={() => setVisibleCount((prev) => prev + 6)}
            >
              Read More
            </button>
          </div>
        )}
      </section>

      <Backtotop />
    </div>
  );
};

export default Programs_organized;
